import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'
import { match } from 'ts-pattern'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import { useCurrentSurveyGroup } from '../../hooks/useCurrentSurveyGroup'
import {
  type IndicatorGroup,
  indicatorGroupLabelI18nKeyMap,
  indicatorMap,
} from '../../utils'

import { CustomerAttributeGroupContent } from './CustomerAttributeGroupContent'
import { IndicatorContent } from './IndicatorContent'
import { QuestionContent } from './QuestionContent'

export type GroupContentProps = {
  indicatorGroup: IndicatorGroup
}

export const GroupContent = ({ indicatorGroup }: GroupContentProps) => {
  const surveyGroup = useCurrentSurveyGroup()
  const { t } = useTranslation()

  return (
    <VStack spacing={1}>
      <Typography variant="heading2">
        {t(indicatorGroupLabelI18nKeyMap[indicatorGroup])}
      </Typography>

      <VStack spacing={2}>
        {match(indicatorGroup)
          .with('fiveSegs', 'nineSegs', (indicatorGroup) =>
            indicatorMap[indicatorGroup].map((indicator) => (
              <IndicatorContent key={indicator} indicator={indicator} />
            )),
          )
          .with('customized', () =>
            R.concat(
              surveyGroup.questions.map((question) => (
                <QuestionContent key={question.id} question={question} />
              )),
              surveyGroup.customerAttributeGroups.map(
                (customerAttributeGroup) => (
                  <CustomerAttributeGroupContent
                    key={customerAttributeGroup.id}
                    customerAttributeGroup={customerAttributeGroup}
                  />
                ),
              ),
            ),
          )
          .exhaustive()}
      </VStack>
    </VStack>
  )
}
